import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth-context';
import { Spinner } from 'react-bootstrap';

const PrivateRoute = ({ children, allowedProfiles }) => {
  const { user, loading } = useAuth();

  if (loading && user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
         &nbsp;Carregando...
      </div>
    );
  }

  const isAuthorized = user && allowedProfiles.includes(user.perfilId);

  return isAuthorized ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
